import { takeEvery, put, call, all, fork } from "redux-saga/effects";
import { message } from "antd";
import { postAdd, getList } from "../../helpers/Helper";
import {
  initiateCall,
  callConnected,
  callFailed,
  hangupCall,
  hangupSuccess,
  submitCallFeedback,
  feedbackSuccess,
  feedbackFailed,
  checkAgentStatus,
  statusCheckSuccess,
} from "./audioCallSlice";

function* InitiateCallSaga({ payload }) {
  try {
    const response = yield call(postAdd, "/thirdparty/sampark/call/", {
      connect_number: payload.phoneNumber,
      purchase_id: payload.purchaseId,
    });
    if (response.status === 200) {
      yield put(callConnected());
    } else {
      const errorMessage = response?.data?.desc || "Call failed";
      message.error(errorMessage);
      yield put(callFailed(errorMessage));
    }
  } catch (error) {
    console.error("Call initiation failed:", error);
    const errorMessage = error?.response?.data?.desc || error?.message || "Failed to initiate call. Please try again.";
    message.error(errorMessage);
    yield put(callFailed(errorMessage));
  }
}

function* HangupCallSaga() {
  try {
    const response = yield call(postAdd, "/thirdparty/sampark/hangup/", {});
    if (response.status === 200) {
      yield put(hangupSuccess());
    } else {
      const errorMessage = response?.data?.desc || "Hangup failed";
      message.error(errorMessage);
      // Still move to feedback even if hangup API fails
      yield put(hangupSuccess());
    }
  } catch (error) {
    console.error("Hangup failed:", error);
    const errorMessage = error?.response?.data?.desc || error?.message || "Hangup failed";
    message.error(errorMessage);
    // Still move to feedback even if hangup API fails
    yield put(hangupSuccess());
  }
}

function* SubmitFeedbackSaga({ payload }) {
  try {
    const response = yield call(postAdd, "/thirdparty/sampark/closecall/", {
      request: "CC",
      agent_id: localStorage.getItem("username") || "",
      callnumber: payload.phoneNumber || "0",
      disposition1: payload.feedbackData.disposition1,
      disposition2: payload.feedbackData.disposition2,
      disposition3: payload.feedbackData.disposition3,
      callback_date: payload.feedbackData.callback_date,
      callnotes: payload.feedbackData.callnotes,
    });
    if (response.status === 200) {
      message.success("Feedback submitted successfully");
      yield put(feedbackSuccess());
    } else {
      const errorMessage = response?.data?.desc || "Failed to submit feedback";
      message.error(errorMessage);
      yield put(feedbackFailed());
    }
  } catch (error) {
    console.error("Feedback submission failed:", error);
    const errorMessage = error?.response?.data?.desc || error?.message || "Failed to submit feedback";
    message.error(errorMessage);
    yield put(feedbackFailed());
  }
}

function* CheckAgentStatusSaga() {
  try {
    const response = yield call(getList, "/thirdparty/sampark/status/");
    if (response) {
      yield put(statusCheckSuccess(response));
      if (response.agent_name) {
        localStorage.setItem("agent_name", response.agent_name);
      }
    }
  } catch (error) {
    console.error("Failed to check call status:", error);
  }
}

function* watchAudioCall() {
  yield takeEvery(initiateCall.type, InitiateCallSaga);
  yield takeEvery(hangupCall.type, HangupCallSaga);
  yield takeEvery(submitCallFeedback.type, SubmitFeedbackSaga);
  yield takeEvery(checkAgentStatus.type, CheckAgentStatusSaga);
}

export default function* audioCallSaga() {
  yield all([fork(watchAudioCall)]);
}
